import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from 'src/environments/environment.prod';


@Injectable({
  providedIn: 'root'
})
export class SectorService {
  public Data = new BehaviorSubject(null)
  constructor(private _HttpClient:HttpClient) { }
  GetSector():Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Sector/Get`);
  }

  DeleteSector(id):Observable<any>{
    return this._HttpClient.get(`${environment.Server_URL}/Sector/Delete?id=${id}`);
  }

  CreateSector(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Sector/Create`,data);
  }
  UpdateSector(data):Observable<any>{
    return this._HttpClient.post(`${environment.Server_URL}/Sector/Update`,data)
  }
}
